import clsx from 'clsx'

const STATUS_CONFIG: Record<string, { bg: string; text: string; label: string }> = {
  open: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Submitted' },
  awaiting_response: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Under Review' },
  in_progress: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'In Progress' },
  resolved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Completed' },
  closed: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Closed' },
}

export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.open
  return (
    <span className={clsx('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium', config.bg, config.text)}>
      {config.label}
    </span>
  )
}

// For kanban columns — maps backend statuses to client-friendly columns
export const KANBAN_COLUMNS = [
  { key: 'submitted', label: 'Submitted', statuses: ['open'] },
  { key: 'review', label: 'Under Review', statuses: ['awaiting_response'] },
  { key: 'progress', label: 'In Progress', statuses: ['in_progress'] },
  { key: 'completed', label: 'Completed', statuses: ['resolved', 'closed'] },
] as const
